import { Component, Input, OnInit } from '@angular/core';
import { UtilService } from '../../service/util.service';
import { ModalController, ToastController } from '@ionic/angular';
import { ProductRequestService } from '../../pages/product-request/product-request.service';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

@Component({
  selector: "app-po-auto-preview",
  templateUrl: "./po-auto-preview.component.html",
  styleUrls: ["./po-auto-preview.component.scss"],
})
export class PoAutoPreviewComponent implements OnInit {
  formProductRequestDetail: any[];
  @Input() productRequestId: any;
  @Input() noPr: any;
  constructor(
    private utilService: UtilService,
    private toastCtrl: ToastController,
    private productRequestService: ProductRequestService,
    private modalController: ModalController
  ) {}

  ngOnInit() {}

  ionViewDidEnter() {
    this.utilService.loadingPresent("Harap tunggu...").then(() => {
      let options = {
        no_pr: this.productRequestId,
      };
      this.productRequestService.getStockByCounter(options).subscribe(
        (response) => {
          this.utilService.loadingDismiss();
          this.formProductRequestDetail = response.results;
          console.log(this.formProductRequestDetail);
        },
        () => {
          this.utilService.loadingDismiss();
          this.toastCtrl
            .create({ duration: 2000, message: "Gagal terhubung ke server" })
            .then((t) => t.present());
        }
      );
    });
  }

  exportToExcel() {
    if (
      !this.formProductRequestDetail ||
      this.formProductRequestDetail.length === 0
    ) {
      console.warn("Tidak ada data untuk diexport");
      return;
    }

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      this.formProductRequestDetail.map((detail, i) => ({
        No: i + 1,
        PCode: detail.pcode,
        Deskripsi: detail.deskripsi,
        "Qty Ytd": detail.qty_ytd,
        "Ns Ytd": detail.net_ytd,
        "Hari Aktif": detail.hari_aktif,
        Asq: detail.asq,
        "Safety Stock": detail.safety_stock,
        PKM: detail.pkm_stock,
        "Last Stock": detail.last_stock,
        "Qty Order": detail.qty_order,
        "Total BDP": detail.total_outstanding,
        "Existing Stock": detail.existing_stock,
        "Total Stock Toko": detail.total_stock,
      }))
    );

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Product Request");

    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const filename = `ProductRequest_${this.productRequestId}.xlsx`;
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), filename);
  }

  async dismissModal() {
    await this.modalController.dismiss();
  }
}
